module.exports = __webpack_public_path__ + "img/leakalert_boards_housing.ae7c3b50.jpg";